/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Title_SuffixInputs */

const da_app_title_suffix = /** @type {(inputs: App_Title_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-forslag til rettelse af prøver`)
};

/** @type {(inputs: App_Title_SuffixInputs) => LocalizedString} */
const en_app_title_suffix = da_app_title_suffix;

/**

* @param {App_Title_SuffixInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const app_title_suffix = /** @type {((inputs?: App_Title_SuffixInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Title_SuffixInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_title_suffix(inputs)
	return /** @type {LocalizedString} */ ("AI-forslag til rettelse af prøver")
});